{
  "external": {
    "name": "inovex GmbH",
    "logoUrl": "https://www.inovex.de/wp-content/uploads/inovex-logo-1.png",
    "signInUrl": "/.auth/login/customer"
  },
  "internal": {
    "name": "Ubica Robotics GmbH",
    "logoUrl": "https://ubica-robotics.eu/wp-content/uploads/2022/08/fav-logo.svg",
    "signInUrl": "/.auth/login/aad"
  },
  "signOutUrl": "/.auth/logout"
}